import { useMemo } from 'react';

import routes from '../app/routes';
import {
  newAirRetrievalGuard,
  newQuoteGuard,
  newShipmentGuard,
} from '../components/guards/pageGuards';
import TopMenu from '../components/menus/TopMenu';
import { useAccounts } from '../hooks/data/auth';
import { config } from '../config/config';

export const MainTopMenu = props => {
  const { loading, isAirRetrievalEnabled } = useAccounts();

  const shipmentMenu = useMemo(() => {
    if (isAirRetrievalEnabled) {
      const menuResult = {
        labelId: 'menu.book',
        children: [
          {
            to: routes.book.newShipment,
            labelId: 'menu.place-order',
            guard: newShipmentGuard,
          },
          {
            to: routes.book.newAirRetrieval,
            labelId: 'menu.air-retrieval',
            guard: newAirRetrievalGuard,
          },
        ],
      };

      if (config.allowExperimentalFeatures) {
        menuResult.children = [
          {
            to: routes.book.newShipmentSingle,
            labelId: 'menu.place-order-single-form',
            guard: newShipmentGuard,
          },
          ...menuResult.children,
        ];
      }
      return menuResult;
    }
    if (config.allowExperimentalFeatures) {
      return {
        labelId: 'menu.book',
        children: [
          {
            to: routes.book.newShipmentSingle,
            labelId: 'menu.place-order-single-form',
            guard: newShipmentGuard,
          },
          {
            to: routes.book.newShipment,
            labelId: 'menu.place-order',
            guard: newShipmentGuard,
          },
        ],
      };
    }

    return {
      to: routes.book.newShipment,
      labelId: 'menu.book',
      guard: newShipmentGuard,
    };
  }, [isAirRetrievalEnabled]);

  const TOP_MENU_ITEMS = useMemo(
    () => [
      { to: routes.monitor, labelId: 'menu.monitor' },
      {
        to: routes.quoting.newQuote,
        labelId: 'menu.quote',
        guard: newQuoteGuard,
      },
      shipmentMenu,
    ],
    [shipmentMenu]
  );

  return loading ? null : <TopMenu {...props} definitions={TOP_MENU_ITEMS} />;
};
